package com.sddamico.draftmachine.models

import com.sddamico.draftmachine.data.DraftOrder
import com.sddamico.draftmachine.data.DraftStatus
import com.sddamico.draftmachine.data.Sport
import kotlinx.serialization.Serializable

/**
 * One league card on the Machine room dashboard (`GET /api/dashboard`). Mirrors the jvmMain
 * `models/DashboardModels.kt`.
 *
 * @param youManage true when the caller is the league manager (vs. a team owner in one of its drafts).
 * @param drafts every draft in the league, newest first and pre-summarized.
 */
@Serializable
data class LeagueCardResponse(
  val league: LeagueSummary,
  val youManage: Boolean,
  val drafts: List<DraftSummary> = emptyList(),
) {
  val latestDraft: DraftSummary? get() = drafts.firstOrNull()
}

/**
 * A draft rolled up for a dashboard card. Derived fields are computed backend-side by
 * `DraftRepository.summarize`.
 *
 * @param sport the draft pool's sport; null = mixed/hybrid pool.
 * @param currentOverallPick the lowest-position unfilled pick (the one on the clock), 1-based.
 * @param onClockSinceIso when the current pick started (previous pick's `pickedAt`, else the draft's start).
 */
@Serializable
data class DraftSummary(
  val draftId: String,
  val status: DraftStatus,
  val draftOrder: DraftOrder? = null,
  val rounds: Int,
  val sport: Sport? = null,
  val teamCount: Int,
  val totalPicks: Int,
  val filledPicks: Int,
  val currentRound: Int? = null,
  val currentOverallPick: Int? = null,
  val onClockTeamName: String? = null,
  val onClockSinceIso: String? = null,
  val completedAtIso: String? = null,
)
